import { LoadingButton, type TpButtonLoadingProps } from '@mentalgrowth/ui-kit-web';
import type { ReactNode } from 'react';
export const UiKitLoadingButton = (props: TpButtonLoadingProps & {
  IconComponent?: ReactNode;
}) => {
  const {
    IconComponent,
    children,
    ...otherProps
  } = props;
  return <LoadingButton {...otherProps} data-sentry-element="LoadingButton" data-sentry-component="UiKitLoadingButton" data-sentry-source-file="index.tsx">
      {IconComponent}
      {children}
    </LoadingButton>;
};